import { createAction, props } from '@ngrx/store';
import { InstaPost } from '../../models';

export const LoadInstaPosts = createAction('[Instagram] Load Instagram Posts');
export const LoadInstaPostsSuccess = createAction('[Instagram] Load Instagram Posts Success', props<{ instaPosts: InstaPost[] }>());
export const LoadInstaPostsFail = createAction('[Instagram] Load Instagram Posts Fail', props<{ error: any }>());
